import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React from "react";
import { Heading2, SecondaryText, Ui } from "@silvertours/front-shared";
import { DisclaimerText, Offer, Offers, OverlayLink, Section } from "./OffersList.styles";
var Background = function(param) {
    var children = param.children, waveColor = param.waveColor;
    return waveColor ? /*#__PURE__*/ _jsx(Ui.Wave, {
        type: "fixed5",
        fullWidth: true,
        backgroundStyle: waveColor,
        children: children
    }) : /*#__PURE__*/ _jsx("div", {
        children: children
    });
};
var OffersList = function(param) {
    var badge = param.badge, _badgeStyle = param.badgeStyle, badgeStyle = _badgeStyle === void 0 ? "light" : _badgeStyle, children = param.children, disclaimer = param.disclaimer, _disclaimerOverlayCTA = param.disclaimerOverlayCTA, disclaimerOverlayCTA = _disclaimerOverlayCTA === void 0 ? "" : _disclaimerOverlayCTA, offerDetails = param.offerDetails, offerDetailsTitle = param.offerDetailsTitle, title = param.title, _titleColor = param.titleColor, titleColor = _titleColor === void 0 ? "default" : _titleColor, waveColor = param.waveColor;
    var ref = _sliced_to_array(React.useState(false), 2), showDialog = ref[0], setShowDialog = ref[1];
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            offerDetails && /*#__PURE__*/ _jsx(Ui.Overlay, {
                open: showDialog,
                onClose: function() {
                    return setShowDialog(false);
                },
                title: offerDetailsTitle,
                width: "wide",
                children: offerDetails
            }),
            /*#__PURE__*/ _jsx(Background, {
                waveColor: waveColor,
                children: /*#__PURE__*/ _jsxs(Section, {
                    children: [
                        badge && /*#__PURE__*/ _jsx(Ui.Badge, {
                            text: badge,
                            type: badgeStyle
                        }),
                        title && /*#__PURE__*/ _jsx(Heading2, {
                            textColor: titleColor,
                            children: title
                        }),
                        /*#__PURE__*/ _jsx(Offers, {
                            hasTitle: !!title,
                            children: React.Children.map(children, function(child) {
                                return /*#__PURE__*/ _jsx(Offer, {
                                    children: child
                                });
                            })
                        }),
                        disclaimer && /*#__PURE__*/ _jsxs(DisclaimerText, {
                            textColor: "grey",
                            children: [
                                disclaimer,
                                " ",
                                /*#__PURE__*/ _jsx(OverlayLink, {
                                    onClick: function() {
                                        return setShowDialog(true);
                                    },
                                    type: "button",
                                    children: /*#__PURE__*/ _jsx(SecondaryText, {
                                        textColor: "grey",
                                        children: disclaimerOverlayCTA
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
export { OffersList };
